import type { Client } from '@frontend/api-types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type AuthReduxState = {
  client?: Client;
  token?: string;
};

const initialState: AuthReduxState = {};

const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    clearAuth: (state) => {
      // eslint-disable-next-line fp/no-mutation
      state.token = undefined;
      // eslint-disable-next-line fp/no-mutation
      state.client = undefined;
    },
    clearClient: (state) => {
      // eslint-disable-next-line fp/no-mutation
      state.client = undefined;
    },
    storeClient: (state, { payload }: PayloadAction<Client>) => {
      // eslint-disable-next-line fp/no-mutation
      state.client = payload;
    },
    storeToken: (state, { payload }: PayloadAction<string>) => {
      // eslint-disable-next-line fp/no-mutation
      state.token = payload;
    },
  },
});

export const { reducer: authReducer } = authSlice;
export const { clearAuth, clearClient, storeClient, storeToken } = authSlice.actions;
